/*
 * This file is part of sepia-themes.
 * Copyright (C) 2024 Data Futures GmbH.
 *
 * sepia-themes is free software; you can redistribute it and/or modify it
 * under the terms of the MIT License; see LICENSE file for more details.
 */

import React from "react";
import ReactDOM from "react-dom";

import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";

import { GeographicMetadataLocationViewer } from "@geo-knowledge-hub/invenio-geographic-components-react";

/**
 * Render the geospatial metadata previewer component.
 */
const componentIdentifiers = [
  "mapContainer", "mapContainerSidebar"
];

componentIdentifiers.forEach(componentIdentifier => {
  const componentDiv = document.getElementById(componentIdentifier);

  if (componentDiv) {
    // parsing the record document
    const recordDocument = JSON.parse(componentDiv.dataset.record);

    // looking for valid locations data
    const featureData = _get(recordDocument, "metadata.locations.features", []);

    if (!_isEmpty(featureData)) {
      ReactDOM.render(
        <>
          <GeographicMetadataLocationViewer
            featuresData={featureData}
            mapConfig={{
              useGeocoding: false,
              useMouseCoordinate: false,
            }}
          />
        </>,
        componentDiv,
      );
    }
  }
})
